<div class="e-selector-dropdown-container">
    <div class="e-left-col">
        <div class="e-selector-content">
            <claims-search-bar
                *ngIf="combinedSearchNodes()?.length"
                [searchOptionsList]="combinedSearchNodes()"
                [hideSelectedItems]="true"
                (selectedSearchOptionEvent)="onSearchSelection($event)"
            ></claims-search-bar>
        </div>
        @if (favouriteNodes()?.length) {
            <div id="e-favourites-tree">
                <div
                    class="e-favourites-heading node-wrap"
                    (click)="toggleFavouriteSection()"
                >
                    <span class="toggle-children-placement">
                        <i [class]="isFavouritesSectionExpanded() ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
                    </span>
                    <span class="e-favourites-title">My Favourite Geographies</span>
                </div>

                @if (isFavouritesSectionExpanded()) {
                    <div>
                        @for (favourite of favouriteNodes(); track favourite.code) {
                            <div class="node-wrap e-favourite-item">
                                @if (favourite.hasCustomName) {
                                    <span
                                        class="toggle-children-placement"
                                        (click)="toggleFavouriteExpand(favourite, $event)"
                                    >
                                        <i [class]="favourite.isExpanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
                                    </span>
                                } @else {
                                    <span class="toggle-children-placement"></span>
                                }

                                <div class="selector-tree-node e-geography-selector">
                                    <div class="node-content-wrapper">
                                        <label class="e-selector-tree-checkbox">
                                            <input
                                                type="checkbox"
                                                [(ngModel)]="favourite.isSelected"
                                                [disabled]="favourite.isDisabled"
                                                (ngModelChange)="onFavouriteToggle(favourite)"
                                            />
                                            <span></span>
                                            <div class="e-node-name">{{ favourite.name }}</div>
                                        </label>
                                    </div>

                                    @if (favourite.isExpanded && favourite.hasCustomName) {
                                        <div class="e-favourite-members">
                                            <span class="e-favourite-member-names">
                                                {{ favourite.memberNames.join(', ') }}
                                            </span>
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        }
        <div id="e-tree" *ngIf="!isDataLoading(); else loading">
            <ng-container>
                <tree-root #tree  [nodes]="treeNodes()" [options]="options" (initialized)="onInitialized()">
                    <ng-template #treeNodeFullTemplate let-node let-index="index" let-templates="templates">
                        <div class="node-wrap" [class]="node.getClass()" [class.tree-node-parent]="node.hasChildren">
                            <tree-node-expander [node]="node"></tree-node-expander>
                            <div class="selector-tree-node e-geography-selector">
                                <div
                                    class="node-content-wrapper"
                                    [class.node-content-wrapper-active]="node.isActive"
                                    [class.node-content-wrapper-focused]="node.isFocused"
                                    [class.tree-node-leaf]="node.isLeaf"
                                    [class.tree-node]="true"
                                >
                                    <label class="e-selector-tree-checkbox">
                                        <input
                                            type="checkbox"
                                            [(ngModel)]="node.data.isSelected"
                                            (ngModelChange)="onSelectedNodeChange()"
                                        />
                                        <span *ngIf="!node.data.isDisabled"></span>
                                        <div class="e-node-name">{{ node.data.name }}</div>
                                    </label>
                                    <claims-context-menu
                                        *ngIf="node?.data?.children && node.data.children.length > 0"
                                        [node]="node"
                                        (menuItemClicked)="onGeographyMenuClick($event, node.data)"
                                    >
                                    </claims-context-menu>
                                </div>
                                <tree-node-children [node]="node" [templates]="templates"></tree-node-children>
                            </div>
                        </div>
                    </ng-template>
                </tree-root>
            </ng-container>
        </div>
        <ng-template #loading>
            <div class="loading-container">
                <div class="loading-spinner">Loading geographies...</div>
            </div>
        </ng-template>
    </div>
    <div class="e-right-col">
        <h2 class="e-selections-heading">YOUR SELECTIONS</h2>
        <button class="e-clear-all" attr.aria-label="Clear all selections" [disabled]="selectedItems()?.length === 0" (click)="onClearAll()">
            Clear All
        </button>
        <div class="e-selections">
            <p *ngIf="selectedItems()?.length === 0" class="e-no-selections">No selections have been made</p>
            <div class="e-selected-list">
                <div *ngFor="let item of selectedItems()" class="e-selected-item">
                    <span class="e-selection-name" title="{{ item.name }}">{{ item.name }}</span>
                    <button
                        class="e-clear-item"
                        attr.aria-label="Remove {{ item.name }} from selection"
                        (click)="onRemoveSelection(item.emiCode)"
                    ></button>
                    <div class="e-breadcrumb-wrap">
                        <span class="e-bread-crumb" title="{{ item.hierarchy }}">{{ item.hierarchy }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="e-button-group">
            <button class="e-button"  (click)="onConfirmSelection()">OK</button>
            <button class="e-button" mat-dialog-close (click)="onCancel()">CANCEL</button>
        </div>
    </div>
</div>